import { createContext, useContext } from 'react'
import { KeyedMutator } from 'swr'

import { PageWorkspace, User, Workspace, WorkspaceUser } from '@/types/index.d'

export type WorkspaceContextType = {
  membership: WorkspaceUser
  mutate: KeyedMutator<any>
  setWorkspaceId: (string: any) => void
  user: User
  workspace: Workspace
  workspaceId: string
  workspaces: PageWorkspace
}

export const WorkspaceContext = createContext<WorkspaceContextType>(undefined)
WorkspaceContext.displayName = 'ClaytonWorkspaceContext'

export const useWorkspaceContext = () => useContext(WorkspaceContext)
